import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { RodadasCoreService } from '../../../core/rodadas-core.service';
import { CardRodada } from '../../../components/card-primecap/model/card-interface';

import { ParametrosPaginacao } from '../../../model/interface/parametros-paginacao';
import { TipoRodadaEnum } from '../../../model/enum/tipo-rodada.enum';
import { Rodada } from '../../../model/rodada';
import { TokenService } from '../../../../../services/token.service';

@Component({
  selector: 'app-rodadas',
  templateUrl: './rodadas.component.html',
  styleUrls: ['./rodadas.component.css']
})
export class RodadasComponent implements OnInit {

  rodadas: Rodada[] = [];
  cardsRodada: CardRodada[] = [];
  cardClass = 'rodadas-card';
  paginacaoPadrao: ParametrosPaginacao = {
    tamanhoPagina: 100
  }

  constructor(
    private rodadaCoreService: RodadasCoreService,
    private router: Router,
    private tokenService: TokenService,
  ) { }

  ngOnInit(): void {
    this.buscarRodadas();
  }

  buscarRodadas() {
    return this.rodadaCoreService.getRodadasHome(this.paginacaoPadrao).subscribe(
      (res) => {
        this.rodadas = res.dados[0].content,
        this.rodadas.forEach(rodada => {
          this.carregaCards(rodada);
        });
      }
    )
  }

  carregaCards(rodada: Rodada): void {
    const cardRodada = new CardRodada();
    cardRodada.banner = rodada.banner;
    cardRodada.logo = rodada.logo;
    cardRodada.valorMinimo = rodada.valorMinimoSucesso
    cardRodada.valorCaptado = rodada.valorCaptado;
    cardRodada.qtdInvestidores = rodada.quantidadeInvestidores;
    cardRodada.empresaNome = rodada.empresaNome;
    cardRodada.empresaUuid = rodada?.empresaUuid;
    cardRodada.setorNome = rodada.empresaSetor;
    cardRodada.setorCorTag = rodada.empresaSetorCorTag;
    cardRodada.valorRodada = rodada.valor;
    cardRodada.textoCard = rodada.textoCard;
    if (rodada.tipoRodada == TipoRodadaEnum.DIVIDA) {
      cardRodada.participacao = rodada.rentabilidadeOferecida;
    } else if (rodada.tipoRodada == TipoRodadaEnum.EQUITY) {
      cardRodada.participacao = rodada.equityOferecido;
    }
    this.cardsRodada.push(cardRodada);
  }

  redirecionarDetalhesCard(): void {
    const isAutenticado: boolean = this.tokenService.carregarUsuarioLogado()?.isAutenticado;

    if (!isAutenticado) {
      this.router.navigate([`login`]);
    }
  }
}
